import BookOpen from '@crehana/compass.icons.outline/BookOpen';
import Cube from '@crehana/compass.icons.outline/Cube';
import Flag from '@crehana/compass.icons.outline/Flag';
import Hana from '@crehana/compass.icons.outline/Hana';
import Lock from '@crehana/compass.icons.outline/Lock';
import People from '@crehana/compass.icons.outline/People';
import Projects from '@crehana/compass.icons.outline/Projects';
import QuestionMarkCircle from '@crehana/compass.icons.outline/QuestionMarkCircle';
import Ranking from '@crehana/compass.icons.outline/Ranking';
import Stats from '@crehana/compass.icons.outline/Stats';
import ActivityFilled from '@crehana/icons/ActivityFilled';
import CirclePlay from '@crehana/icons/CirclePlay';
import PlusCircle from '@crehana/icons/fill/PlusCircle';
import LevelCompleteVertical from '@crehana/icons/LevelCompleteVertical';
import Book from '@crehana/icons/outline/Book';
import Report2 from '@crehana/icons/outline/Report2';
import Rocket from '@crehana/icons/outline/Rocket';
import ShoppingCart from '@crehana/icons/outline/ShoppingCart';
import SkillXp from '@crehana/icons/outline/SkillXp';
import UserApps from '@crehana/icons/outline/UserApps';
import Settings from '@crehana/icons/Settings';
import UsersOutline from '@crehana/icons/UsersOutline';

import type { RouteType } from '@/shared/components/DashboardTemplate/types';

export const ROUTE_KEY = {
  MY_SHOP: 'MY_SHOP',
  CONTENT: 'CONTENT',
  CONTENT_ROUTES: 'CONTENT_ROUTES',
  CONTENT_COURSES: 'CONTENT_COURSES',
  STATISTICS: 'STATISTICS',
  MANAGE: 'MANAGE',
  MANAGE_TEAMS: 'MANAGE_TEAMS',
  MANAGE_AUTOMATION: 'MANAGE_AUTOMATION',
  MANAGE_CUSTOM_FIELDS: 'MANAGE_CUSTOM_FIELDS',
  MANAGE_ATTRIBUTES: 'MANAGE_ATTRIBUTES',
  COURSES: 'COURSES',
  ELEVATE: 'MENU_ROUTE_ELEVATE',
  ELEVATE_COURSES: 'MENU_ROUTE_ELEVATE_COURSES',
  SKILL_XP: 'SKILL_XP',
  SKILL_XP_EVOLUTION: 'SKILL_XP_EVOLUTION',
  GAMIFICATION: 'GAMIFICATION',
  TALENT: 'TALENT',
  COURSE_DETAIL_GENERAL: 'COURSE_DETAIL_GENERAL',
  COURSE_DETAIL_PROJECTS: 'COURSE_DETAIL_PROJECTS',
  COURSE_DETAIL_REVIEWS: 'COURSE_DETAIL_REVIEWS',
  CONFIGURATION: 'CONFIGURATION',
  REPORTS: 'REPORTS',
  FEEDBACK: 'FEEDBACK',
  PATHS_ECOMMERCE: 'PATHS_ECOMMERCE',
  MARKET: 'MENU_MARKET',
  INTEGRATIONS: 'INTEGRATIONS',
  HANA_AI: 'HANA_AI',
  SESSIONS_LIVES: 'MENU_ROUTE_ELEVATE_SESSIONS_LIVES',
  KNOWLEDGE_HUB_DOCUMENTS: 'CONTENT_KNOWLEDGE_HUB_DOCUMENTS',
  KNOWLEDGE_HUB_CATALOG: 'CONTENT_KNOWLEDGE_HUB_CATALOG',
  CONTENT_CERTIFICATES_GALLERY: 'CONTENT_CERTIFICATES_GALLERY',
  HANA_AI_ASSISTANT: 'HANA_AI_ASSISTANT',
};

export enum PAGES {
  MY_SHOP = 'panel/market',
  CONTENT = 'admin/content',
  STATISTICS = 'estadisticas',
  MANAGE = 'administrar',
  TALENT_SUITE = 'talent-suite',
  PROJECTS_NEW = 'projects',
  KNOWLEDGE_HUB_DOCUMENTS = 'documents',
  KNOWLEDGE_HUB_CATALOG = 'catalog',
  PROJECTS = 'proyectos',
  SKILL_IQ = 'skill-iq',
  SKILL_XP_EVOLUTION = 'skill-xp-evolution',
  CLASSROOM = 'classroom',
  STUDIO_DASHBOARD = 'content',
  STUDIO = 'studio',
  ELEVATE = 'Elevate',
  GAMIFICATION = 'gamification',
  CONFIGURATION = 'configuracion',
  ADMIN_GUIDE = 'guia-del-administrador',
  ORGANIZATIONS = 'organizaciones',
  INDUCTION = 'induccion',
  INTEGRATIONS = 'integraciones',
  HANA_AI = 'estadisticas/generales',
  TALENT = 'talento',
  TEAM_GUIDE = 'guia-del-lider',
  REPORTS = 'reportes',
  COURSES = 'courses',
  PATHS = 'paths',
  PATHS_COMMERCE = 'paths-commerce',
  SESSIONS_LIVES = 'lives',
  CERTIFICATES_GALLERY = 'certificates',
}

export const PANEL_PATH = {
  COURSE_GENERAL: `/org/[slug]/panel/${PAGES.STATISTICS}/cursos/[originalId]/`,
  REPORTS_SCHEDULE: `/org/[slug]/panel/${PAGES.REPORTS}/programar/`,
  REPORTS_PERSONALIZE: `/org/[slug]/panel/${PAGES.REPORTS}/personalizado/`,
  MANAGE_ATTRIBUTES: `/org/[slug]/panel/${PAGES.MANAGE}/atributos/`,
  CUSTOM_FIELDS_LIST: `/org/[slug]/panel/${PAGES.MANAGE}/campos-personalizados/`,
  CUSTOM_FIELDS_NEW: `/org/[slug]/panel/${PAGES.MANAGE}/campos-personalizados/nuevo-campo-personalizado/`,
  CUSTOM_FIELDS_EDIT: `/org/[slug]/panel/${PAGES.MANAGE}/campos-personalizados/editar-campo-personalizado/[originalId]/`,
  CUSTOM_FIELDS_ASSIGN: `/org/[slug]/panel/${PAGES.MANAGE}/campos-personalizados/asignar/`,
  AUTOMATION_LIST: `/org/[slug]/panel/${PAGES.MANAGE}/automatizaciones/`,
  AUTOMATION_NEW: `/org/[slug]/panel/${PAGES.MANAGE}/automatizaciones/nueva-automatizacion/`,
  WORKFLOW_CREATE: `/org/[slug]/panel/${PAGES.MANAGE}/automatizaciones/create/`,
  AUTOMATION_COURSE_NEW: `/org/[slug]/panel/automations/course/new-automation/`,
  AUTOMATION_COURSE_EDIT: `/org/[slug]/panel/automations/course/edit-automation/[originalId]/`,
  AUTOMATION_EDIT: `/org/[slug]/panel/${PAGES.MANAGE}/automatizaciones/editar-automatizacion/[originalId]/`,
  AUTOMATION_USER_DETAIL: `/org/[slug]/panel/${PAGES.MANAGE}/automatizaciones/[originalId]/detalle-usuarios/`,
  USERS_UPLOAD: `/org/[slug]/panel/subir-usuarios/`,
  USERS_UPLOAD_DETAIL: `/org/[slug]/panel/subir-usuarios/[originalId]/imports/`,
  USERS_DELETION: `/org/[slug]/panel/eliminar-usuarios/`,
  TEAMS_DELETION: `/org/[slug]/panel/eliminar-equipos/`,
  USER_STATISTICS: `/org/[slug]/panel/${PAGES.STATISTICS}/especificas/[userSlug]/`,
  AREAS_SEDES: `/org/[slug]/panel/${PAGES.TALENT_SUITE}/areas-y-sedes/areas`,
  AREAS_UPLOAD: `/org/[slug]/panel/${PAGES.TALENT_SUITE}/subir-areas/`,
  TRACK_DETAIL: `/org/[slug]/panel/${PAGES.STATISTICS}/grupales/[originalId]/`,
  COURSE_DETAIL: `/org/[slug]/panel/${PAGES.STATISTICS}/cursos/[originalId]/`,
  HANA_AI: `/org/[slug]/panel/estadisticas/generales/`,
  MANAGE_USERS: `/org/[slug]/panel/${PAGES.MANAGE}/usuarios/`,
  MANAGE_TEAMS: `/org/[slug]/panel/${PAGES.MANAGE}/equipos/`,
  HANA_AI_ASSISTANT: `/org/[slug]/ai/admin/assistant/help-desk/categories/`,
};

export const MY_SHOP = {
  key: ROUTE_KEY.MARKET,
  path: `/org/[slug]/${PAGES.MY_SHOP}/`,
  icon: ShoppingCart,
  label: 'MENU_ROUTE_MY_SHOP',
  nested: [
    {
      key: ROUTE_KEY.MY_SHOP,
      path: `/org/[slug]/${PAGES.MY_SHOP}/config`,
      label: 'ROUTE_MARKET_CONFIG',
      tourSelector: '',
    },
    {
      key: 'PATHS_ECOMMERCE',
      path: `/org/[slug]/${PAGES.MY_SHOP}/paths-commerce`,
      label: 'MENU_ROUTE_CONTENT_3',
      tourSelector: '',
    },
  ],
};

// se cambio a [org]/panel/content/paths-commerce y se eliminara este menu
export const CONTENT = {
  key: ROUTE_KEY.CONTENT,
  path: `/org/[slug]/${PAGES.CONTENT}`,
  icon: PlusCircle,
  label: 'MENU_ROUTE_CONTENT',
  nested: [
    {
      key: ROUTE_KEY.CONTENT_ROUTES,
      path: `/org/[slug]/${PAGES.CONTENT}/paths/`,
      label: 'MENU_ROUTE_CONTENT_1',
    },
    {
      key: ROUTE_KEY.CONTENT_COURSES,
      path: `/org/[slug]/${PAGES.CONTENT}/courses/`,
      label: 'MENU_ROUTE_CONTENT_2',
    },
  ],
};

/**
 * REPORTS is inside of STATISTICS module.
 */
export const REPORTS: RouteType = {
  key: ROUTE_KEY.REPORTS,
  path: `/org/[slug]/panel/${PAGES.REPORTS}/`,
  icon: Report2,
  activeIcon: Report2,
  label: 'MENU_ROUTE_REPORTS',
  hideNested: true,
  nested: [
    {
      key: 'REPORTS_PUBLISHED',
      path: `/org/[slug]/panel/${PAGES.REPORTS}/publicados/`,
      label: 'REPORTS_NESTED_ROUTE_1',
      tourSelector: '',
    },
    {
      key: 'REPORTS_PERSONALIZE',
      path: `/org/[slug]/panel/${PAGES.REPORTS}/personalizado/`,
      label: 'REPORTS_NESTED_ROUTE_2',
      tourSelector: '',
    },
    {
      key: 'REPORTS_SCHEDULED',
      path: `/org/[slug]/panel/${PAGES.REPORTS}/programados/`,
      label: 'REPORTS_NESTED_ROUTE_3',
      tourSelector: '',
    },
    {
      key: 'REPORTS_SCHEDULE',
      path: `/org/[slug]/panel/${PAGES.REPORTS}/programar/`,
      label: 'REPORTS_NESTED_ROUTE_4',
      tourSelector: '',
    },
  ],
};

export const STATISTICS: RouteType = {
  key: ROUTE_KEY.STATISTICS,
  path: `/org/[slug]/panel/${PAGES.STATISTICS}`,
  icon: Stats,
  activeIcon: Stats,
  label: 'MENU_ROUTE_METRICS_NEW',
  tourSelector: 'menu-item-statistics',
  nested: [
    {
      key: 'STATISTICS_GENERAL',
      path: `/org/[slug]/panel/${PAGES.STATISTICS}`,
      label: 'STATISTICS_LEARNING',
      tourSelector: 'menu-item-statistics',
      hideNested: true,
      nested: [
        {
          key: 'STATISTICS_GENERAL',
          path: `/org/[slug]/panel/${PAGES.STATISTICS}/generales`,
          label: 'GENERAL_NESTED_ROUTE_1',
        },
        {
          key: 'STATISTICS_USERS',
          path: `/org/[slug]/panel/${PAGES.STATISTICS}/especificas`,
          label: 'GENERAL_NESTED_ROUTE_2',
        },
        {
          key: 'STATISTICS_TRACKS',
          path: `/org/[slug]/panel/${PAGES.STATISTICS}/grupales`,
          label: 'GENERAL_NESTED_ROUTE_3',
        },
        {
          key: 'STATISTICS_COURSES',
          path: `/org/[slug]/panel/${PAGES.STATISTICS}/cursos`,
          label: 'GENERAL_NESTED_ROUTE_4',
          hideNested: true,
          nested: [
            {
              key: ROUTE_KEY.COURSE_DETAIL_GENERAL,
              path: PANEL_PATH.COURSE_GENERAL,
              label: 'GENERAL_COURSES_NESTED_ROUTE_1',
            },
            {
              key: ROUTE_KEY.COURSE_DETAIL_PROJECTS,
              path: PANEL_PATH.COURSE_GENERAL,
              label: 'GENERAL_COURSES_NESTED_ROUTE_2',
            },
            {
              key: ROUTE_KEY.COURSE_DETAIL_REVIEWS,
              path: PANEL_PATH.COURSE_GENERAL,
              label: 'GENERAL_COURSES_NESTED_ROUTE_3',
            },
          ],
        },
      ],
    },
    REPORTS,
  ],
};

export const MANAGE: RouteType = {
  key: ROUTE_KEY.MANAGE,
  path: `/org/[slug]/panel/${PAGES.MANAGE}/`,
  icon: People,
  activeIcon: People,
  label: 'MENU_ROUTE_ADMIN',
  tourSelector: 'menu-item-manage',
  nested: [
    {
      key: 'MANAGE_USERS',
      path: PANEL_PATH.MANAGE_USERS,
      label: 'ROUTE_MANAGE_NESTED_2',
      tourSelector: 'menu-item-manage-users',
    },
    {
      key: ROUTE_KEY.MANAGE_ATTRIBUTES,
      path: `/org/[slug]/panel/${PAGES.MANAGE}/atributos/`,
      label: 'ROUTE_MANAGE_NESTED_1',
      tourSelector: 'menu-item-manage-attributes',
    },
    {
      key: ROUTE_KEY.MANAGE_TEAMS,
      path: `/org/[slug]/panel/${PAGES.MANAGE}/equipos/`,
      label: 'ROUTE_MANAGE_NESTED_4',
      tourSelector: 'menu-item-manage-teams',
    },
    {
      key: ROUTE_KEY.MANAGE_CUSTOM_FIELDS,
      path: `/org/[slug]/panel/${PAGES.MANAGE}/campos-personalizados/`,
      label: 'ROUTE_MANAGE_NESTED_6',
      tourSelector: 'menu-item-manage-custom-fields',
    },
    {
      key: ROUTE_KEY.MANAGE_AUTOMATION,
      path: `/org/[slug]/panel/${PAGES.MANAGE}/automatizaciones/`,
      label: 'ROUTE_MANAGE_NESTED_5',
      hideNested: true,
      nested: [
        {
          key: 'AUTOMATION_NEW',
          path: PANEL_PATH.AUTOMATION_NEW,
          label: 'ROUTE_MANAGE_NESTED_5_1',
        },
        {
          key: 'AUTOMATION_EDIT',
          path: PANEL_PATH.AUTOMATION_EDIT,
          label: 'ROUTE_MANAGE_NESTED_5_2',
        },
        {
          key: 'AUTOMATION_USER_DETAIL',
          path: PANEL_PATH.AUTOMATION_USER_DETAIL,
          label: 'ROUTE_MANAGE_NESTED_5_3',
        },
      ],
    },
  ],
};

export const PROJECTS: RouteType = {
  key: 'PROJECTS',
  path: `/org/[slug]/panel/${PAGES.PROJECTS}`,
  icon: Projects,
  activeIcon: Projects,
  label: 'MENU_ROUTE_PROJECTS',
  tourSelector: 'menu-item-projects',
  nested: [],
};

export const SKILL_IQ: RouteType = {
  key: ROUTE_KEY.SKILL_XP,
  path: `/org/[slug]/panel/${PAGES.SKILL_IQ}`,
  icon: ActivityFilled,
  activeIcon: ActivityFilled,
  label: 'MENU_ROUTE_SKILL_IQ',
  tourSelector: 'menu-item-skill-iq',
  nested: [
    {
      key: 'SKILL_IQ_GENERAL',
      path: `/org/[slug]/panel/${PAGES.SKILL_IQ}/general`,
      label: 'SKILL_IQ_GENERAL_NESTED_1',
      tourSelector: 'menu-item-skill-iq-general',
    },
    {
      key: 'SKILL_IQ_USERS',
      path: `/org/[slug]/panel/${PAGES.SKILL_IQ}/usuarios`,
      label: 'SKILL_IQ_GENERAL_NESTED_2',
      tourSelector: 'menu-item-skill-iq-users',
    },
    {
      key: 'SKILL_IQ_GROUPS',
      path: `/org/[slug]/panel/${PAGES.SKILL_IQ}/grupos`,
      label: 'SKILL_IQ_GENERAL_NESTED_3',
      tourSelector: 'menu-item-skill-iq-tracks',
    },
  ],
};

export const SKILL_XP_EVOLUTION: RouteType = {
  key: ROUTE_KEY.SKILL_XP_EVOLUTION,
  path: `/org/[slug]/panel/${PAGES.SKILL_XP_EVOLUTION}`,
  icon: SkillXp,
  activeIcon: SkillXp,
  label: 'MENU_ROUTE_SKILL_XP_EVOLUTION',
  hideNested: true,
  nested: [
    {
      key: 'LAUNCHED',
      path: `/org/[slug]/panel/${PAGES.SKILL_XP_EVOLUTION}/lanzados`,
      label: 'SKILL_XP_EVOLUTION_NESTED_1',
    },
    // NOTE: Hide this route temporarily until Product team decides to show it or remove it. @julito
    /* {
      key: 'RESULTS',
      path: `/org/[slug]/panel/${PAGES.SKILL_XP_EVOLUTION}/resultados`,
      label: 'SKILL_XP_EVOLUTION_NESTED_2',
    }, */
  ],
};

export const CLASSROOM: RouteType = {
  key: 'CLASSROOM',
  path: `/org/[slug]/panel/${PAGES.CLASSROOM}`,
  icon: CirclePlay,
  activeIcon: CirclePlay,
  label: 'MENU_ROUTE_STUDIO',
  tourSelector: 'menu-item-classrooms',
  nested: [
    {
      key: 'PUBLISHED',
      path: `/org/[slug]/panel/${PAGES.CLASSROOM}/cursos-publicados`,
      label: 'CLASSROOM_NESTED_1',
      tourSelector: 'menu-item-classrooms-published',
    },
    {
      key: 'UNPUBLISHED',
      path: `/org/[slug]/panel/${PAGES.CLASSROOM}/cursos-no-publicados`,
      label: 'CLASSROOM_NESTED_2',
      tourSelector: 'menu-item-classrooms-unpublished',
    },
  ],
};

export const STUDIO_DASHBOARD: RouteType = {
  key: ROUTE_KEY.ELEVATE,
  path: `/org/[slug]/panel/${PAGES.STUDIO_DASHBOARD}`,
  icon: BookOpen,
  activeIcon: BookOpen,
  label: 'MENU_ROUTE_ELEVATE_CONTENT',
  tourSelector: 'menu-item-classrooms',
  nested: [
    {
      key: 'MENU_ROUTE_ELEVATE_COURSES',
      path: `/org/[slug]/panel/content/${PAGES.COURSES}`,
      label: 'MENU_ROUTE_CONTENT_2',
      tourSelector: '',
      rightIcon: Lock,
    },
    {
      key: 'CONTENT_PATHS',
      path: `/org/[slug]/panel/content/${PAGES.PATHS}`,
      label: 'MENU_ROUTE_CONTENT_1',
      tourSelector: 'menu-item-manage-tracks',
    },
    {
      key: 'MENU_ROUTE_ELEVATE_SESSIONS_LIVES',
      path: `/org/[slug]/panel/content/${PAGES.SESSIONS_LIVES}`,
      label: 'MENU_ROUTE_CONTENT_4',
      tourSelector: '',
      rightIcon: Lock,
    },
    {
      key: ROUTE_KEY.KNOWLEDGE_HUB_DOCUMENTS,
      path: `/org/[slug]/panel/content/${PAGES.KNOWLEDGE_HUB_DOCUMENTS}`,
      label: 'MENU_ROUTE_KNOWLEDGE_HUB_DOCUMENTS',
      nested: [],
    },
    {
      key: ROUTE_KEY.KNOWLEDGE_HUB_CATALOG,
      path: `/org/[slug]/panel/content/${PAGES.KNOWLEDGE_HUB_CATALOG}`,
      label: 'MENU_ROUTE_KNOWLEDGE_HUB_CATALOG',
      nested: [],
    },
    {
      key: 'CONTENT_PROJECTS',
      path: `/org/[slug]/panel/content/${PAGES.PROJECTS_NEW}`,
      label: 'MENU_ROUTE_PROJECTS',
      tourSelector: 'menu-item-projects',
      nested: [],
    },
    {
      key: ROUTE_KEY.CONTENT_CERTIFICATES_GALLERY,
      path: `/org/[slug]/panel/content/${PAGES.CERTIFICATES_GALLERY}/`,
      label: 'MENU_ROUTE_CERTIFICATES_GALLERY',
      tourSelector: 'menu-item-certificates',
      rightIcon: Lock,
    },
  ],
};

export const GAMIFICATION: RouteType = {
  key: ROUTE_KEY.GAMIFICATION,
  path: `/org/[slug]/panel/${PAGES.GAMIFICATION}`,
  icon: Ranking,
  activeIcon: Ranking,
  label: 'MENU_ROUTE_GAMIFICATION',
  tourSelector: '',

  nested: [
    {
      key: 'GAMIFICATION_PROGRESS',
      path: `/org/[slug]/panel/${PAGES.GAMIFICATION}/progress`,
      label: 'GAMIFICATION_NESTED_1',
      tourSelector: '',
    },
    {
      key: 'GAMIFICATION_REWARDS',
      path: `/org/[slug]/panel/${PAGES.GAMIFICATION}/rewards`,
      label: 'GAMIFICATION_NESTED_2',
      tourSelector: '',
    },
  ],
};

export const TALENT: RouteType = {
  key: ROUTE_KEY.TALENT,
  path: `/org/[slug]/panel/${PAGES.TALENT}`,
  icon: Flag,
  activeIcon: Flag,
  label: 'MENU_ROUTE_TALENT',
  tourSelector: '',
  nested: [
    {
      key: 'TALENT_GESTION',
      path: `/org/[slug]/panel/${PAGES.TALENT}/gestion/`,
      label: 'ROUTE_TALENT_NESTED_1',
      tourSelector: '',
    },
    {
      key: 'TALENT_ENGAGEMENT',
      path: `/org/[slug]/panel/${PAGES.TALENT}/engagement/`,
      label: 'ROUTE_TALENT_NESTED_2',
      tourSelector: '',
    },
    {
      key: 'TALENT_PERFORMANCE',
      path: `/org/[slug]/panel/${PAGES.TALENT}/performance/`,
      label: 'ROUTE_TALENT_NESTED_3',
      tourSelector: '',
    },
  ],
};

export const CONFIGURATION: RouteType = {
  key: ROUTE_KEY.CONFIGURATION,
  path: `/org/[slug]/panel/${PAGES.CONFIGURATION}`,
  icon: Settings,
  activeIcon: Settings,
  label: 'MENU_ROUTE_CONFIG',
  tourSelector: '',
  hideNested: true,
  nested: [
    {
      key: 'ACCOUNT',
      path: `/org/[slug]/panel/${PAGES.CONFIGURATION}/cuenta/`,
      label: 'CONFIGURATION_NESTED_1',
      tourSelector: '',
    },
    {
      key: 'APPEARANCE',
      path: `/org/[slug]/panel/${PAGES.CONFIGURATION}/apariencia/`,
      label: 'CONFIGURATION_NESTED_2',
      tourSelector: '',
    },
    {
      key: 'COMMUNICATIONS',
      path: `/org/[slug]/panel/${PAGES.CONFIGURATION}/comunicaciones/`,
      label: 'CONFIGURATION_NESTED_3',
      tourSelector: '',
    },
  ],
};

export const ADMIN_GUIDE: RouteType = {
  key: 'ADMIN_GUIDE',
  path: `/org/[slug]/panel/${PAGES.ADMIN_GUIDE}`,
  icon: QuestionMarkCircle,
  activeIcon: Book,
  label: 'MENU_ROUTE_GUIDE',
  tourSelector: 'admin-guide',
  nested: [],
};

export const ADMIN_GUIDE_NEWS = {
  nested: [
    {
      key: 'UPDATES',
      path: `/org/[slug]/panel/${PAGES.ADMIN_GUIDE}/novedades/updates/`,
      label: 'NEW_COURSES_NESTED_1',
      tourSelector: '',
    },
    {
      key: 'COURSES',
      path: `/org/[slug]/panel/${PAGES.ADMIN_GUIDE}/novedades/cursos/`,
      label: 'NEW_COURSES_NESTED_2',
      tourSelector: '',
    },
  ],
};

export const CORP_STATISTICS: RouteType = {
  key: 'CORP_STATISTICS',
  path: `/org/[slug]/panel/corp/${PAGES.STATISTICS}/generales/`,
  icon: LevelCompleteVertical,
  activeIcon: LevelCompleteVertical,
  label: 'MENU_ROUTE_METRICS_2',
  tourSelector: '',
  nested: [],
};

export const CORP_MANAGE: RouteType = {
  key: 'CORP_MANAGE',
  path: `/org/[slug]/panel/corp/${PAGES.MANAGE}`,
  icon: UsersOutline,
  activeIcon: UsersOutline,
  label: 'MENU_ROUTE_ADMIN_2',
  tourSelector: '',
  nested: [
    {
      key: 'ORGANIZATIONS',
      path: `/org/[slug]/panel/corp/${PAGES.MANAGE}/organizaciones/`,
      label: 'ROUTE_CORP_MANAGE_1',
      tourSelector: '',
    },
    {
      key: 'ADMINS',
      path: `/org/[slug]/panel/corp/${PAGES.MANAGE}/admins/`,
      label: 'ROUTE_CORP_MANAGE_2',
      tourSelector: '',
    },
  ],
};

export const CORP_CONFIGURATION: RouteType = {
  key: 'CONFIGURATION',
  path: `/org/[slug]/panel/corp/${PAGES.CONFIGURATION}`,
  icon: Settings,
  activeIcon: Settings,
  label: 'MENU_ROUTE_CONFIG_2',
  tourSelector: '',
  hideNested: true,
  nested: [
    {
      key: 'ACCOUNT',
      path: `/org/[slug]/panel/corp/${PAGES.CONFIGURATION}/cuenta/`,
      label: 'CONFIGURATION_NESTED_1',
      tourSelector: '',
    },
    {
      key: 'APPEARANCE',
      path: `/org/[slug]/panel/corp/${PAGES.CONFIGURATION}/apariencia/`,
      label: 'CONFIGURATION_NESTED_2',
      tourSelector: '',
    },
    // WIP @nando
    // {
    //   key: 'COMMUNICATIONS',
    //   path: `/org/[slug]/panel/corp/${PAGES.CONFIGURATION}/comunicaciones`,
    //   label: 'CONFIGURATION_NESTED_3',
    //   tourSelector: '',
    // },
  ],
};

export const INDUCTION: RouteType = {
  key: 'INDUCTION',
  path: `/org/[slug]/panel/${PAGES.INDUCTION}`,
  icon: Rocket,
  activeIcon: Rocket,
  label: 'MENU_ROUTE_INDUCTION',
  tourSelector: '',
  nested: [
    {
      key: 'HOME',
      path: `/org/[slug]/panel/${PAGES.INDUCTION}/inicio/`,
      label: 'INDUCTION_NESTED_1',
      tourSelector: '',
    },
    {
      key: 'WORKFLOW',
      path: `/org/[slug]/panel/${PAGES.INDUCTION}/workflow/`,
      label: 'INDUCTION_NESTED_2',
      tourSelector: '',
    },
    {
      key: 'FOLLOW_UP',
      path: `/org/[slug]/panel/${PAGES.INDUCTION}/seguimiento/`,
      label: 'INDUCTION_NESTED_3',
      tourSelector: '',
    },
    {
      key: 'PHASES',
      path: `/org/[slug]/panel/${PAGES.INDUCTION}/etapas/`,
      label: 'INDUCTION_NESTED_4',
      tourSelector: '',
    },
  ],
};

export const INTEGRATIONS: RouteType = {
  key: ROUTE_KEY.INTEGRATIONS,
  path: `/org/[slug]/panel/${PAGES.INTEGRATIONS}`,
  icon: Cube,
  activeIcon: Cube,
  label: 'MENU_ROUTE_INTEGRATIONS',
  hideNested: true,
  nested: [
    {
      key: 'DISCOVER',
      path: `/org/[slug]/panel/${PAGES.INTEGRATIONS}/descubre/`,
      label: 'INTEGRATIONS_NESTED_ROUTE_1',
    },
    {
      key: 'MYINTEGRATIONS',
      path: `/org/[slug]/panel/${PAGES.INTEGRATIONS}/mis-integraciones/`,
      label: 'INTEGRATIONS_NESTED_ROUTE_2',
    },
    {
      key: 'CREDENTIALS',
      path: `/org/[slug]/panel/${PAGES.INTEGRATIONS}/credenciales/`,
      label: 'INTEGRATIONS_NESTED_ROUTE_4',
    },
  ],
};

export const HANA_AI: RouteType = {
  key: 'HANA_AI',
  path: `/org/[slug]/panel/estadisticas/generales/`,
  icon: Hana,
  activeIcon: Hana,
  label: 'MENU_ROUTE_HANA_AI',
  tourSelector: '',
  nested: [],
};

export const INTEGRATIONS_APP_PANEL: RouteType = {
  key: 'INTEGRATIONS_APP_PANEL',
  path: `/org/[slug]/panel/${PAGES.INTEGRATIONS}/personalizacion/`,
  icon: Cube,
  activeIcon: Cube,
  label: 'MENU_ROUTE_INTEGRATIONS',
  tourSelector: '',
  nested: [
    {
      key: 'PERSONALIZATION',
      path: `/org/[slug]/panel/${PAGES.INTEGRATIONS}/personalizacion/`,
      label: 'INTEGRATIONS_NESTED_ROUTE_3',
      tourSelector: '',
    },
  ],
};

export const LEADER_STATISTICS: RouteType = {
  key: 'LEADER_STATISTICS',
  path: `/org/[slug]/panel/lider/[teamId]/${PAGES.STATISTICS}`,
  icon: LevelCompleteVertical,
  activeIcon: LevelCompleteVertical,
  label: 'MENU_LEADER_METRICS',
  tourSelector: '',
  nested: [
    {
      key: 'LEADER_STATISTICS_GENERAL',
      path: `/org/[slug]/panel/lider/[teamId]/${PAGES.STATISTICS}/general/`,
      label: 'LEADER_METRICS_NESTED_1',
      tourSelector: '',
    },
  ],
};

export const HELP: RouteType = {
  key: 'HELP',
  label: 'MENU_ROUTE_HELP',
  icon: QuestionMarkCircle,
  path: `/org/[slug]/panel/guia-del-administrador/`,
  nested: [],
};

export const FEEDBACK: RouteType = {
  key: ROUTE_KEY.FEEDBACK,
  label: 'Sugerencias',
  openInNewTab: true,
  icon: UserApps,
  path: 'https://canny.io/api/redirects/sso?companyID=[companyId]&ssoToken=[ssoToken]&redirect=[redirect]',
  nested: [],
};

export const HANA_AI_ASSISTANT: RouteType = {
  key: ROUTE_KEY.HANA_AI_ASSISTANT,
  path: `/org/[slug]/ai/admin/assistant/help-desk/categories/`,
  icon: People,
  activeIcon: People,
  label: 'MENU_ROUTE_HANA_AI_ASSISTANT',
  tourSelector: '',
  nested: [],
};

export const ROUTES: RouteType[] = [
  HANA_AI,
  STATISTICS,
  MANAGE,
  STUDIO_DASHBOARD,
  SKILL_XP_EVOLUTION,
  GAMIFICATION,
  MY_SHOP,
  TALENT,
  INTEGRATIONS,
  HANA_AI_ASSISTANT,
];

export const LOWER_MENU_ROUTES: RouteType[] = [CONFIGURATION, ADMIN_GUIDE];

export const CORP_ROUTES: RouteType[] = [CORP_STATISTICS, CORP_MANAGE];

export const CORP_LOWER_MENU_ROUTES: RouteType[] = [CORP_CONFIGURATION];

export const LEADER_ROUTES: RouteType[] = [LEADER_STATISTICS];

export const LOWER_LEADER_ROUTES: RouteType[] = [FEEDBACK];
